.lds-default {
  display: inline-block;
  position: relative;
  width: 30px;
  height: 30px;
}

.lds-default div {
  position: absolute;
  width: 3px;
  height: 3px;
  background: var(--main-text);
  border-radius: 50%;
  animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
  animation-delay: 0s;
  top: 14px;
  left: 23px;
}

.lds-default div:nth-child(2) {
  animation-delay: -0.157142857s;
  top: 8px;
  left: 20px;
}

.lds-default div:nth-child(3) {
  animation-delay: -0.314285714s;
  top: 5px;
  left: 14px;
}

.lds-default div:nth-child(4) {
  animation-delay: -0.471428571s;
  top: 8px;
  left: 8px;
}

.lds-default div:nth-child(5) {
  animation-delay: -0.628571429s;
  top: 14px;
  left: 5px;
}

.lds-default div:nth-child(6) {
  animation-delay: -0.785714286s;
  top: 20px;
  left: 8px;
}

.lds-default div:nth-child(7) {
  animation-delay: -0.942857143s;
  top: 23px;
  left: 14px;
}

.lds-default div:nth-child(8) {
  animation-delay: -1.1s;
  top: 20px;
  left: 20px;
}

@keyframes lds-default {
  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.3);
  }
}
